@if (view(); as toast) {
  <div
    class="offline-sync-toast offline-sync-toast--{{ toast.tone }}"
    role="status"
    aria-live="polite"
    data-cy="offline-sync-toast">
    <span class="offline-sync-toast__icon" aria-hidden="true">
      <i [class]="toast.icon"></i>
    </span>
    <span class="offline-sync-toast__text">
      <strong class="offline-sync-toast__title">{{ toast.title }}</strong>
      <span class="offline-sync-toast__detail">{{ toast.detail }}</span>
      @if (canRecover()) {
        <span class="offline-sync-toast__actions">
          <button
            type="button"
            class="offline-sync-toast__action"
            data-cy="offline-sync-toast-retry"
            (click)="onRetry()">
            Tentar de novo
          </button>
          <button
            type="button"
            class="offline-sync-toast__action offline-sync-toast__action--ghost"
            data-cy="offline-sync-toast-discard"
            (click)="onDiscard()">
            Descartar
          </button>
        </span>
      }
    </span>
    <button
      type="button"
      class="offline-sync-toast__close"
      aria-label="Fechar aviso de sincronização"
      data-cy="offline-sync-toast-close"
      (click)="dismiss()">
      <i class="uil uil-times" aria-hidden="true"></i>
    </button>
  </div>
}
